import styled, { css } from 'styled-components'

import { buttonDefaultStyles, buttonTemplates } from '../templates'

export const Container = styled.button<ContainerProps>`
  ${({ theme, template, ...rest }) => {
    const buttonTemplate = buttonTemplates[template] || buttonTemplates.primary
    return css`
      ${buttonDefaultStyles({ theme, props: { ...rest } })}
      ${buttonTemplate?.({ theme, ...rest })}
    `
  }}
`
